var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import nem from 'nem-sdk';
import encoding from 'encoding-japanese';
import axios from 'axios';
import helper from './helper';
var nemWrapper = /** @class */ (function () {
    function nemWrapper() {
        this.endpoint = '';
        this.host = '';
        this.port = '';
        this.net = '';
        this.helper = new helper();
        //タイムスタンプ解析
        this.dispTimeStamp = function (timeStamp) {
            var NEM_EPOCH = Date.UTC(2015, 2, 29, 0, 6, 25, 0);
            var d = new Date(timeStamp * 1000 + NEM_EPOCH);
            var strDate = d.getFullYear()
                + "年" + (d.getMonth() + 1)
                + '月' + d.getDate()
                + '日' + d.getHours()
                + ':' + d.getMinutes();
            return strDate;
        };
        //UQを時間に変換
        this.amount_hd = function (uqcoin) {
            var uq_x = uqcoin / 800;
            var uq_fract_d = uq_x * 10 % 10 / 10;
            var day = String(uq_x).split(".")[0];
            var hours = String(uq_fract_d * 800 / 100).split(".")[0];
            var uq_fract_m = Number(uq_fract_d * 800 / 100) * 10 % 10 / 10;
            var uq_fract_m2 = String(uq_fract_m * 100).split(".")[0];
            var minutes = String(Number(uq_fract_m2) / 100 * 60).split(".")[0];
            var amount_hd = "";
            if (day !== "0") {
                amount_hd = amount_hd + day + "日 ";
            }
            if (hours !== "0") {
                amount_hd = amount_hd + hours + "時間 ";
            }
            if (minutes !== "0") {
                amount_hd = amount_hd + minutes + "分";
            }
            if (amount_hd === "") {
                amount_hd = "0分";
            }
            return amount_hd;
        };
        // NIS設定.
        this.host = 'https://nem02.neluta.win';
        this.port = '7891';
        //this.host = 'http://go.nem.ninja'
        //this.port = 'hugealice3'
        this.net = nem.model.network.data.mainnet.id;
        this.endpoint = nem.model.objects.create("endpoint")(this.host, this.port);
    }
    // NISの状態確認.
    nemWrapper.prototype.isNIS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nem.com.requests.endpoint.heartbeat(this.endpoint)];
                    case 1:
                        result = _a.sent();
                        if (result.message === 'ok') {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // アカウント作成.
    nemWrapper.prototype.createAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var walletName, password, wallet, common, account, result;
            return __generator(this, function (_a) {
                walletName = "wallet";
                password = "wallet";
                wallet = nem.model.wallet.createPRNG(walletName, password, this.net);
                common = nem.model.objects.create("common")(password, "");
                account = wallet.accounts[0];
                nem.crypto.helpers.passwordToPrivatekey(common, account, account.algo);
                result = {
                    address: account.address,
                    privateKey: common.privateKey
                };
                console.log("アドレス生成:" + account.address);
                return [2 /*return*/, result];
            });
        });
    };
    // アカウント情報取得.
    nemWrapper.prototype.getAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nem.com.requests.account.data(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    nemWrapper.prototype.getAccountMo = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("mosaics.owned");
                        return [4 /*yield*/, nem.com.requests.account.mosaics.owned(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        console.log("mosaics.mosaicname");
                        console.log("mosaics.quantity");
                        result.data.forEach(function (data) {
                            console.log(data.mosaicId.name);
                            console.log(data.quantity);
                        });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    nemWrapper.prototype.getUnconfirmed = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, nem.com.requests.account.transactions.unconfirmed(this.endpoint, address)];
                    case 1:
                        result = _a.sent();
                        console.log(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金（NEM）
    nemWrapper.prototype.sendNem = function (address, privateKey, amount, message) {
        return __awaiter(this, void 0, void 0, function () {
            var common, transferTransaction, transactionEntity, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        common = nem.model.objects.create('common')('', privateKey);
                        transferTransaction = nem.model.objects.create('transferTransaction')(address, amount, message);
                        transactionEntity = nem.model.transactions.prepare('transferTransaction')(common, transferTransaction, this.net);
                        return [4 /*yield*/, nem.model.transactions.send(common, transactionEntity, this.endpoint)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // 送金（Mosaic）
    nemWrapper.prototype.sendMosaics = function (address, privateKey, mosaics, message, networkTimestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var common, transferTransaction, mosaicDefinitionMetaDataPair, transactionEntity, timeStamp, deadline, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        common = nem.model.objects.create('common')('', privateKey);
                        transferTransaction = nem.model.objects.create('transferTransaction')(address, 1, message);
                        return [4 /*yield*/, this.getMosaicDefinitionMetaDataPair(this.endpoint, mosaics)];
                    case 1:
                        mosaicDefinitionMetaDataPair = _a.sent();
                        mosaics.forEach(function (mosaic) {
                            var fullMosaicName = mosaic.namespace + ':' + mosaic.name;
                            if ((mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.id.namespaceId === mosaic.namespace) &&
                                (mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.id.name === mosaic.name)) {
                                var divisibility_1 = 0;
                                mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition.properties.forEach(function (prop) {
                                    if (prop.name === 'divisibility') {
                                        divisibility_1 = prop.value;
                                    }
                                });
                                var quantity = mosaic.amount * Math.pow(10, divisibility_1);
                                var mosaicAttachment = nem.model.objects.create('mosaicAttachment')(mosaic.namespace, mosaic.name, quantity);
                                transferTransaction.mosaics.push(mosaicAttachment);
                            }
                        });
                        transactionEntity = nem.model.transactions.prepare('mosaicTransferTransaction')(common, transferTransaction, mosaicDefinitionMetaDataPair, this.net);
                        timeStamp = Math.floor(networkTimestamp / 1000);
                        deadline = timeStamp + 3600;
                        // 3. prepare後に、作成されたエンティティの間違ったタイムスタンプを、正しい値で「上書き」する
                        transactionEntity.timeStamp = timeStamp;
                        transactionEntity.deadline = deadline;
                        return [4 /*yield*/, nem.model.transactions.send(common, transactionEntity, this.endpoint)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // モザイク定義取得.
    nemWrapper.prototype.getMosaicDefinitionMetaDataPair = function (endpoint, mosaics) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var mosaicDefinitionMetaDataPair = nem.model.objects.get('mosaicDefinitionMetaDataPair');
                        var mosaicCount = 0;
                        mosaics.forEach(function (mosaic) {
                            var mosaicAttachment = nem.model.objects.create('mosaicAttachment')(mosaic.namespace, mosaic.name, mosaic.amount);
                            var result = nem.com.requests.namespace.mosaicDefinitions(endpoint, mosaicAttachment.mosaicId.namespaceId)
                                .then(function (result) {
                                mosaicCount = mosaicCount + 1;
                                var neededDefinition = nem.utils.helpers.searchMosaicDefinitionArray(result.data, [mosaic.name]);
                                var fullMosaicName = nem.utils.format.mosaicIdToName(mosaicAttachment.mosaicId);
                                if (undefined === neededDefinition[fullMosaicName]) {
                                    console.error('Mosaic not found !');
                                    return;
                                }
                                mosaicDefinitionMetaDataPair[fullMosaicName] = {};
                                mosaicDefinitionMetaDataPair[fullMosaicName].mosaicDefinition = neededDefinition[fullMosaicName];
                                var supply = 0;
                                result.data.some(function (obj) {
                                    if ((obj.mosaic.id.namespaceId === mosaic.namespace) &&
                                        (obj.mosaic.id.name === mosaic.name)) {
                                        obj.mosaic.properties.some(function (prop) {
                                            if (prop.name === 'initialSupply') {
                                                supply = prop.value;
                                                return true;
                                            }
                                        });
                                    }
                                });
                                mosaicDefinitionMetaDataPair[fullMosaicName].supply = supply;
                                if (mosaicCount >= mosaics.length) {
                                    resolve(mosaicDefinitionMetaDataPair);
                                }
                            }).catch(function (e) {
                                console.error(e);
                                reject(e);
                            });
                        });
                    })];
            });
        });
    };
    // QRコードjson取得.
    nemWrapper.prototype.getQRcodeJson = function (v, type, name, addr, amount, msg) {
        // v:2, type:1 アカウント, type:2 請求書
        var amountVal = amount * Math.pow(10, 6);
        var json = {
            type: type,
            data: {
                name: name,
                addr: addr,
                amount: amountVal,
                msg: msg
            },
            v: v
        };
        var jsonString = JSON.stringify(json);
        var result = encoding.codeToString(encoding.convert(this.getStr2Array(jsonString), 'UTF8'));
        return result;
    };
    // NEMの可分性取得
    nemWrapper.prototype.getNemDivisibility = function () {
        return Math.pow(10, 6);
    };
    nemWrapper.prototype.getStr2Array = function (str) {
        var array = [];
        for (var i = 0; i < str.length; i++) {
            array.push(str.charCodeAt(i));
        }
        return array;
    };
    //トランザクション履歴取得
    nemWrapper.prototype.getTransactions = function (address, toAddress) {
        var _this = this;
        console.log(address);
        console.log(this.endpoint);
        console.log(toAddress);
        var servant = [];
        var transferTx = nem.com.requests.account.transactions.all(this.endpoint, address).then(function (res) {
            res.data.forEach(function (prop) {
                console.log(prop);
                if (prop.transaction.mosaics !== undefined) {
                    if (prop.transaction.message.payload !== undefined && prop.transaction.recipient == toAddress) {
                        var tran = prop.transaction;
                        var signature = tran.signer;
                        var recipient = tran.recipient;
                        var timestamp = _this.dispTimeStamp(tran.timeStamp);
                        var amount = tran.amount / 1000000;
                        var amount_hd = _this.amount_hd(amount);
                        var message = _this.utf8_hex_string_to_string(tran.message.payload);
                        var flag = true;
                        if (message != null && message.indexOf("[[[年次有給申請]]]") !== -1) {
                            //console.log(prop.transaction.mosaics[1].mosaicId.name);
                            message = message.replace("[[[年次有給申請]]]", "");
                        }
                        else if (message != null) {
                            message = message.replace("[[[返却]]]", "UQ返却分");
                            flag = false;
                        }
                        console.log([timestamp, amount, amount_hd, message, flag]);
                        servant.push([timestamp, amount, amount_hd, message, flag]);
                    }
                }
            });
        });
        console.log(servant);
        return servant;
    };
    nemWrapper.prototype.getApplicationLogsFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!(address != null && address != "")) return [3 /*break*/, 3];
                        url = this.helper.path + "auth_users/uq_application_log/" + address;
                        console.log("in getaccountlist");
                        return [4 /*yield*/, this.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, axios.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data.data[0]);
                                result = response.data.data[0];
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    //トランザクション履歴取得
    nemWrapper.prototype.getApplicationLogs = function (address) {
        var _this = this;
        var servant = [];
        var transferTx = this.getApplicationLogsFromAPI(address).then(function (res) {
            console.log(res);
            res.forEach(function (prop) {
                console.log(prop);
                var timestamp = _this.toDate(prop[0]);
                var amount = prop[2];
                var amount_hd = _this.amount_hd(amount);
                var message = prop[3];
                if (message != null)
                    message = message.replace("[[[年次有給申請]]]", "");
                console.log([timestamp, amount, amount_hd, message]);
                servant.push([timestamp, amount, amount_hd, message]);
            });
        });
        console.log(servant);
        return servant;
    };
    //timestamp（文字列）を時間に変換
    nemWrapper.prototype.toDate = function (date) {
        var Y = date.substr(0, 4);
        var M = date.substr(5, 2);
        var D = date.substr(8, 2);
        var time = date.substr(11, 5);
        return Y + "年" + M + "月" + D + "日" + time;
    };
    //メッセージ解析
    nemWrapper.prototype.utf8_hex_string_to_string = function (hex_str1) {
        var bytes2 = this.hex_string_to_bytes(hex_str1);
        var str2 = this.utf8_bytes_to_string(bytes2);
        return str2;
    };
    nemWrapper.prototype.hex_to_byte = function (hex_str) {
        return parseInt(hex_str, 16);
    };
    nemWrapper.prototype.hex_string_to_bytes = function (hex_str) {
        var result = [];
        if (hex_str && hex_str.length) {
            for (var i = 0; i < hex_str.length; i += 2) {
                result.push(this.hex_to_byte(hex_str.substr(i, 2)));
            }
        }
        return result;
    };
    nemWrapper.prototype.utf8_bytes_to_string = function (arr) {
        if (arr == null)
            return null;
        var result = "";
        var i;
        while (i = arr.shift()) {
            if (i <= 0x7f) {
                result += String.fromCharCode(i);
            }
            else if (i <= 0xdf) {
                var c = ((i & 0x1f) << 6);
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
            else if (i <= 0xe0) {
                var c = ((arr.shift() & 0x1f) << 6) | 0x0800;
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
            else {
                var c = ((i & 0x0f) << 12);
                c += (arr.shift() & 0x3f) << 6;
                c += arr.shift() & 0x3f;
                result += String.fromCharCode(c);
            }
        }
        return result;
    };
    //メッセージ解析end
    nemWrapper.prototype.getCompanyInfoFromAPI = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result, url, headers, access_token, uid, client, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!(address != null && address != "")) return [3 /*break*/, 3];
                        url = this.helper.path + "auth_users/company_info/" + address;
                        console.log("in getcompanyinfofromapi");
                        return [4 /*yield*/, this.helper.load("Headers")
                            //let headers = await this.helper.loadHeaders()
                        ];
                    case 1:
                        headers = _a.sent();
                        if (!(headers != null)) return [3 /*break*/, 3];
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        return [4 /*yield*/, axios.get(url, {
                                headers: { "Content-Type": "application/json",
                                    "access-token": access_token,
                                    "uid": uid,
                                    "client": client },
                                data: {}
                            }).then(function (response) {
                                console.log('status:', response.status); // 200
                                console.log(response.data);
                                result = response.data.data[0];
                                // catchでエラー時の挙動を定義する
                            }).catch(function (error) {
                                if (error.response && error.response.status == "401") {
                                    console.log("please login");
                                    _this.helper.pleaseLogin();
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    //UQを受け取っているかどうか
    nemWrapper.prototype.checkRecieveUq = function (transaction, yourMosaicName, address) {
        return __awaiter(this, void 0, void 0, function () {
            var mosaics_flag;
            return __generator(this, function (_a) {
                mosaics_flag = false;
                if (transaction.mosaics) {
                    mosaics_flag = transaction.mosaics.filter(function (value) {
                        return value.mosaicId.name === yourMosaicName;
                    });
                }
                if (transaction.recipient != null && transaction.recipient == address) {
                    if (mosaics_flag) {
                        return [2 /*return*/, true];
                    }
                }
                return [2 /*return*/, false];
            });
        });
    };
    return nemWrapper;
}());
export default nemWrapper;



//////////////////
// WEBPACK FOOTER
// ./src/ts/nemWrapper.ts
// module id = 30
// module chunks = 1